<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.ASSIGNED_SALES_PERSON"
  [dataService]="salespersonSelectorService"
  [formControl]="salesPersonOptionControl"
  [isRequired]="true"
  [multiple]="true"
  [supportedDataTypes]=""
  [supportDataPassing]="false"
  [extraData]="true"
></automata-automation-replacement-chips>
